import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  amount() {
    return faker.number.int();
  },

  description(n) {
    return `Coupon #${n}`;
  },
});
